import { ErrrorComponent } from './components/errror/errror.component';
import { ResetPasswordComponent } from './../auth/reset-password/reset-password.component';
import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
// import menu items
import { HomeComponent } from "./components/home/home.component";
import { VersionComponent } from "./components/version/version.component";
import { TokenComponent } from "./components/token/token.component";
import { LogoffComponent } from "../login/logoff.component";
import { LoginComponent } from "../login/login.component";
import { PageNotFoundComponent } from "./components/navmenu/not-found.component";
// services
import { CanDeactivateGuard } from "../services/can-deactivate-guard.service";
import { DialogService } from "../services/dialog.service";
import { AuthGuardPatientService } from "../auth/auth-guard-patient.service";
import { AuthGuardPatientProcedureService } from "../auth/auth-guard-patient-procedure.service";
import { AuthGuardProcedureProtocolService } from "../auth/auth-guard-procedure-protocol.service";
import { AuthGuardOrganisationService } from "../auth/auth-guard-organisation.service";
import { AuthGuardReferralService } from "../auth/auth-guard-referral.service";
import { AuthGuardReportsService } from "../auth/auth-guard-reports.service";
import { AuthCallbackComponent } from "../auth-callback/auth-callback.component";
import { ImportsComponent } from "./components/imports/imports.component";
import { DentallyWizardComponent } from "./components/wizards/dentally/dentallywizard.component";
import { DentallyConnectComponent } from "./components/wizards/dentally/connect/dentally-connect.component";
import { DentallyLearnComponent } from "./components/wizards/dentally/learn/dentally-learn.component";
import { DentallyStartComponent } from "./components/wizards/dentally/start/dentally-start.component";
import { MsalGuard } from "src/auth/msal/msal-guard";
import { ContentGuard } from '../app/content.guard'

const appRoutes: Routes = [
  {
    path: "imports",
    component: ImportsComponent,
    canActivate: [MsalGuard],
  },
  { path: "home", component: HomeComponent },
  { path: "login", component: LoginComponent },
  {
    path: "wizard/dentally",
    component: DentallyWizardComponent,
    canActivate: [MsalGuard],
    children: [
      {
        path: "connect",
        pathMatch: "full",
        component: DentallyConnectComponent,
      },
      {
        path: "learn",
        pathMatch: "full",
        component: DentallyLearnComponent,
      },
      {
        path: "start",
        pathMatch: "full",
        component: DentallyStartComponent,
      },
      {
        path: "callback",
        data: { isCallback: true },
        pathMatch: "full",
        component: DentallyConnectComponent,
      },
    ],
  },
  {
    path: "logoff",
    component: LogoffComponent,
    canActivate: [MsalGuard],
  },
  {
    path: "reset-password",
    component: ResetPasswordComponent,    
  },
  {
    path: "version",
    component: VersionComponent,
    canActivate: [MsalGuard],
  },
  {
      path:"error",
      component: ErrrorComponent
  },
  { path: "token", component: TokenComponent, canActivate: [MsalGuard] },
  { path: "auth-callback", component: AuthCallbackComponent },
  {
    path: "cases",
    loadChildren: "../cases/cases.module#CasesModule",
    canActivate: [MsalGuard],
  },
  {
    path: "procedures",
    loadChildren:
      "../patient-procedures/patient-procedures.module#PatientProceduresModule",
    canActivate: [AuthGuardPatientProcedureService],
  },
  {
    path: "patient",
    loadChildren: "../patient/patient.module#PatientModule",
    canActivate: [AuthGuardPatientService],
  },
  {
    path: "org-settings",
    loadChildren: "../org-settings/org-settings.module#OrgSettingsModule",
    canActivate: [AuthGuardOrganisationService],
  },
  {
    path: "analytics",
    loadChildren: "../reports/reports.module#ReportsModule",
    canActivate: [AuthGuardReportsService],
  },
  {
    path: "content",
    loadChildren: "../content/content.module#ContentModule",
    canActivate: [AuthGuardProcedureProtocolService,ContentGuard],
  },
  {
    path: "recalls",
    loadChildren: "../recall-calls/recall-calls.module#RecallCallsModule",
    canActivate: [MsalGuard],
  },
  {
    path: "referrals",
    loadChildren: "../referrals/referrals.module#ReferralsModule",
    canActivate: [MsalGuard, AuthGuardReferralService],
  },  
  { path: "", redirectTo: "home", pathMatch: "full" },
  {
    path: "**",
    component: PageNotFoundComponent,
    canActivate: [MsalGuard],
  }
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule],
  providers: [CanDeactivateGuard, DialogService],
})
export class AppRoutingModule {}
